<template>
  <div class="flex flex-col items-center justify-center gap-2">
    <div class="relative flex items-center justify-center">
      <!-- <div
        class="absolute w-40 h-40 transform -translate-x-1/2 -translate-y-1/2 border-2 border-dotted rounded-full border-jm_white opacity-40 top-1/2 left-1/2 animate-spin-slow"
      ></div>
      <div
        class="absolute transform -translate-x-1/2 -translate-y-1/2 border-2 border-dotted rounded-full border-jm_white w-36 opacity-60 h-36 top-1/2 left-1/2 animate-spin-slower"
      ></div>
      <div
        class="absolute w-32 h-32 transform -translate-x-1/2 -translate-y-1/2 border-2 border-dotted rounded-full border-jm_white opacity-32 top-1/2 left-1/2 animate-spin-slowest"
      ></div> -->
      <button
        @click="triggerMethod()"
        class="relative z-10 flex items-center justify-center h-10 font-bold leading-5 text-white uppercase rounded-xl border-jm_orange w-72"
        :class="globalStore.timesLeftToPlay <= 0 ? '' : 'bg-jm_orange'"
      >
        <span
          @click="handleEnoughClick"
          v-if="globalStore.timesLeftToPlay <= 0"
          class="flex items-center justify-center px-2 py-2 text-xl w-72 bg-jm_orange rounded-xl"
          >{{ $t("game_controls.got_it") }}</span
        >
        <span
          v-else-if="imageSelected"
          class="flex items-center justify-center text-xl w-72 min-h-10 rounded-xl"
        >
          {{ $t("game_controls.play_again") }}
          <img :src="reload" class="w-4 ml-3" />
        </span>
        <!-- <img class="h-full pulse" v-else :src="textImage" /> -->
        <span class="text-base font-bold uppercase" v-else
          >{{ $t("game_controls.push_for_your_move") }}</span
        >
      </button>
    </div>
    <div
      class="flex flex-row items-center justify-center h-10 gap-2 px-4 py-2 font-bold text-white border-2 border-jm_white w-72 rounded-xl bg-white/10 backdrop-blur-lg"
      @click="handleButtonClick"
      v-if="globalStore.timesLeftToPlay > 0 && !imageSelected"
    >
      <img class="w-3" :src="arrow" />
      <span class="text-base uppercase">{{ $t("game_controls.back") }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import reload from "@/assets/images/misc/reload.svg";
import EventBus from "@/plugins/EventBus";
import { ref, onMounted, onBeforeUnmount, defineEmits, watch } from "vue";
import textImage from "@/assets/images/misc/text.svg";
import CloseButton from "@/components/CloseButton.vue";
import { useGameTracking } from "@/composables/useGameTracking";
import { useGlobalStore } from "@/stores/global";
import arrow from "@/assets/images/misc/Glyph.svg";

const globalStore = useGlobalStore();
const { kpiTracker, session } = useGameTracking();

const emit = defineEmits(["isStopped"]);
const imageSelected = ref(false);
const clickCounter = ref(0);
let keyHeldDown = false;

const triggerMethod = () => {
  if (imageSelected.value || globalStore.currentStep === "ageCheck") {
    globalStore.playTapSound();
  } else {
    globalStore.playBuzzerSound();
    if (!kpiTracker.voucherRedeemed.value) {
      kpiTracker.setVoucherRedeemed(true);
      session
        .updateSessionProgress(kpiTracker.getKpiData(), {
          step: "move_stopped",
        })
        .catch((error) => {
          console.error("[PushButton] Error while tracking move stop:", error);
        });
    }
  }

  imageSelected.value = !imageSelected.value;
  EventBus.emit("startGame", imageSelected.value);
  emit("isStopped", imageSelected.value);

  clickCounter.value++;

  if (clickCounter.value === 2) {
    kpiTracker.incrementTimesPlayed();
    clickCounter.value = 0;
  }
};

const handleKeydown = (event: KeyboardEvent) => {
  if (!keyHeldDown && (event.key === "b" || event.key === "Enter")) {
    keyHeldDown = true;
    triggerMethod();
  }
};

const handleKeyup = (event: KeyboardEvent) => {
  keyHeldDown = false;
};

const handleButtonClick = () => {
  globalStore.changeStep("peopleCheck");
  globalStore.playTapSound();
  kpiTracker.resetGame();
  globalStore.resetGame(kpiTracker.selectedPerson.value);
};

const handleEnoughClick = () => {
  globalStore.changeStep("ageCheck");
  globalStore.playTapSound();
  globalStore.setShouldShowDailyLimitScreen(false);
  globalStore.setCapturedPhotoFile(null);
  globalStore.setCapturedPhotoDataUrl(null);
  globalStore.setUploadedPhotoItemId(null);
  globalStore.setRaffleResult(null);
  kpiTracker.resetGame();
  kpiTracker.resetTrackingData();
  globalStore.resetGame(kpiTracker.selectedPerson.value);
};

watch(
  () => globalStore.timesLeftToPlay,
  async (newValue) => {
    if (newValue <= 0) {
      if (kpiTracker.gamePlayTimeStart.value !== null) {
        const endTime = Date.now();
        const playTimeSeconds = Math.floor(
          (endTime - kpiTracker.gamePlayTimeStart.value) / 1000
        );
        kpiTracker.setGamePlayTimeSeconds(playTimeSeconds);
      }
      // Keep progress at 2 (game_started) - don't change it
      // Update session with progress "game_finished" and mark_session_as_finished: true
      // This will set has_finished_game = true in the backend
      console.log(
        "[PushButton] Updating session with progress 'game_finished' and mark_session_as_finished: true (has_finished_game will be set to true by backend)"
      );
      await session.updateSessionProgress(
        kpiTracker.getKpiData(),
        { step: "game_finished" },
        true
      );
      globalStore.setRaffleResult(null);

      globalStore.changeStep("photoCapture");
    }
  }
);

onMounted(() => {
  window.addEventListener("keydown", handleKeydown);
  window.addEventListener("keyup", handleKeyup);
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", handleKeydown);
  window.removeEventListener("keyup", handleKeyup);
});
</script>

<style lang="scss" scoped>
@import "@/assets/sass/main.sass";

@keyframes spin-slow {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes spin-slower {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(-360deg);
  }
}

@keyframes spin-slowest {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.animate-spin-slow {
  animation: spin-slow 26s linear infinite;
}

.animate-spin-slower {
  animation: spin-slower 28s linear infinite;
}

.animate-spin-slowest {
  animation: spin-slowest 30s linear infinite;
}

.pulse {
  animation: pulse-animation 2s infinite;
  border-radius: 50%;
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
    transform: scale(1.1);
  }
}

.back-button {
  position: absolute;
  left: 0;
  bottom: 0;
  margin-bottom: 28px;
  cursor: pointer;
}
</style>
